import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { PlaceLookUpDirective } from '../place-look-up.directive';
import { AgmCoreModule } from '@agm/core';
// import { MatChipsModule } from '@angular/material/chips';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';


import { ThankYouDialogComponent } from '../dialogs/thank-you-dialog/thank-you-dialog.component';
import { SignInComponent } from '../dialogs/sign-in/sign-in.component';
import { MatesRideDialogComponent } from '../dialogs/mates-ride-dialog/mates-ride-dialog.component';
import { InfoDialogComponent } from '../dialogs/info-dialog/info-dialog.component';
// import { PlaceLookUpDirective } from '../place-look-up.directive';
const sharedModules: any[] = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  MatInputModule,
  MatSelectModule,
  MatRadioModule,
  MatIconModule,
  MatDialogModule,
  MatDatepickerModule,
  MatSnackBarModule,
  MatCheckboxModule,
  MatCardModule
];

const sharedComponents: any[] = [SignInComponent, ThankYouDialogComponent, MatesRideDialogComponent, InfoDialogComponent];
@NgModule({
  imports: [
    sharedModules,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDa2rwqWCT3DxtyUfzL5XyZxOZYWoLJ_5U',
      libraries: ['places'],
    }),
  ],
  exports: [sharedModules, sharedComponents, PlaceLookUpDirective],
  entryComponents: [sharedComponents],
  declarations: [sharedComponents, PlaceLookUpDirective, MatesRideDialogComponent, InfoDialogComponent],
})
export class SharedModule {}
